// import React from "react";
// import { Link } from "react-router-dom";
// import PropTypes from "prop-types";
// import { FiPlay } from "react-icons/fi";

// // Robust slugify function
// const slugify = (text) => {
//     if (!text || typeof text.toString !== "function") return "unknown";
//     return text
//         .toString()
//         .toLowerCase()
//         .replace(/\s+/g, "-")
//         .replace(/[^\w-]+/g, "")
//         .replace(/--+/g, "-")
//         .replace(/^-+/, "")
//         .replace(/-+$/, "");
// };

// const ASSET_BASE_URL = process.env.REACT_APP_ASSET_BASE_URL;

// const BlogList = ({ data, StyleVar }) => {
//     const categories = Array.isArray(data.categories) ? data.categories : [];


//     const cate = categories.map((value, i) =>
//         value ? (
//             <Link to={`/category/${slugify(value)}`} key={i}>
//                 {value}
//                 {i !== categories.length - 1 && ","}
//             </Link>
//         ) : null
//     );

//     return (
//         <div className={`rn-card ${StyleVar}`}>
//             <div className="inner">
//                 <div className="thumbnail position-relative">
//                     <Link to={`/content-details/${data.id}`} className="image">
                    
                    
//                         <img
//                             src={`${ASSET_BASE_URL}/storage/${data.image}`}
//                             alt="Content Image"
//                             onError={(e) => {
//                                 e.target.onerror = null;
//                                 e.target.src = "/images/default-image.jpg"; // your fallback image
//                             }}
//                         />
//                     </Link>

//                     {data.video_url && (
//                         <Link to={`/content-details/${data.id}`}>
//                             <div
//                                 className="play-button-overlay d-flex align-items-center justify-content-center"
//                                 style={{
//                                     position: "absolute",
//                                     top: "50%",
//                                     left: "50%",
//                                     transform: "translate(-50%, -50%)",
//                                     backgroundImage:
//                                         "linear-gradient(95deg, rgb(5, 157, 255) 15%, rgb(101, 73, 213) 45%, rgb(227, 63, 161) 75%, rgb(251, 83, 67) 100%)",
//                                     borderRadius: "50%",
//                                     width: "70px",
//                                     height: "70px",
//                                     color: "#fff",
//                                     fontSize: "30px",
//                                     boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
//                                     cursor: "pointer",
//                                 }}
//                             >
//                                 <FiPlay />
//                             </div>
//                         </Link>
//                     )}
//                 </div>
//                 <div className="content">
//                     <ul className="rn-meta-list">
//                         <li>
//                             <Link to={`/archive/${slugify(data.author || "Unknown")}`}>
//                                 {data.author || "Unknown Author"}
//                             </Link>
//                         </li>
//                         <li className="separator">/</li>
//                         <li>{data.date}</li>
//                     </ul>
//                     <h4 className="title">
//                         <Link to={`/content-details/${data.id}`}>
//                             {data.title}
//                         </Link>
//                     </h4>
//                     <div className="post-categories">{cate}</div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// BlogList.propTypes = {
//     data: PropTypes.object.isRequired,
//     StyleVar: PropTypes.string,
// };

// export default BlogList;




import React, { useState } from "react";
import PropTypes from "prop-types";
import FsLightbox from "fslightbox-react";
import { FiPlay } from "react-icons/fi";

const ASSET_BASE_URL = process.env.REACT_APP_ASSET_BASE_URL;

const getVideoThumbnail = (url) => {
  let videoId = "";
  if (url.includes("youtu.be/")) {
    videoId = url.split("youtu.be/")[1].split("?")[0];
  } else if (url.includes("v=")) {
    videoId = url.split("v=")[1].split("&")[0];
  }
  return {
    videoId,
    thumbnail: `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`,
    lightboxUrl: `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`,
  };
};

const BlogList = ({ data, StyleVar }) => {
  const [isOpen, setIsOpen] = useState(false);

  const { thumbnail, lightboxUrl } = data.video_url
    ? getVideoThumbnail(data.video_url)
    : {
        thumbnail: `${ASSET_BASE_URL}/storage/${data.image}`,
        lightboxUrl: "",
      };

  return (
    <>
      <div
        className={`rounded-xl overflow-hidden ${StyleVar}`}
        style={{ cursor: "pointer", position: "relative", aspectRatio: "16/9" }}
        onClick={() => setIsOpen(true)}
      >
        <img
          src={thumbnail}
          alt="thumbnail"
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />

        <div
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "none",
          }}
        >
          <div
            style={{
              background:
                "linear-gradient(95deg, rgb(5, 157, 255) 15%, rgb(101, 73, 213) 45%, rgb(227, 63, 161) 75%, rgb(251, 83, 67) 100%)",
              width: "60px",
              height: "60px",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <FiPlay style={{ fontSize: "20px", color: "#ffffff" }} />
          </div>
        </div>
      </div>

      {data.video_url && <FsLightbox toggler={isOpen} sources={[lightboxUrl]} key={lightboxUrl} />}
    </>
  );
};

BlogList.propTypes = {
  data: PropTypes.object.isRequired,
  StyleVar: PropTypes.string,
};

export default BlogList;
